<div class="flex flex-col gap-4">
  <elcia-text-input [control]="form.controls.name" [label]="'folder.name' | translate"/>
  <elcia-user-dropdown [control]="form.controls.userIds" [label]="'assigned'" [isMulti]="true"/>
  @if (parentFolder()) {
    <p class="text-xs text-surface-500">
      {{ 'app.will-create-in' | translate }} <strong>{{ parentFolder()!.name }}</strong>
    </p>
  }
</div>
